import {
  type PlatformCapabilitiesQueryHookResult,
  usePlatformCapabilitiesQuery
} from '../__generated__/apollo-hooks';

type ProfilingSession = {
  user: { email: string; username?: string | null };
  startedAt: Date;
};

type CapabilityProfiling = {
  deployed: boolean;
  isActive: boolean;
  session: ProfilingSession | null;
};

type Capabilities = {
  connector: boolean;
  changelog: boolean;
  codeSearch: boolean;
  moddy: boolean;
  profiling: CapabilityProfiling;
  loading: boolean;
  error: PlatformCapabilitiesQueryHookResult['error'];
  refetch: PlatformCapabilitiesQueryHookResult['refetch'];
};

const EMPTY_PROFILING: CapabilityProfiling = {
  deployed: false,
  isActive: false,
  session: null
};

export const useCapabilities = (): Capabilities => {
  const { data, loading, error, refetch } = usePlatformCapabilitiesQuery({
    fetchPolicy: 'cache-first'
  });

  if (!data) {
    return {
      connector: false,
      changelog: false,
      codeSearch: false,
      moddy: false,
      profiling: EMPTY_PROFILING,
      loading,
      error,
      refetch
    };
  }

  const session = data.capabilities.profiling.session ?? null;

  return {
    connector: data.capabilities.connector,
    changelog: data.capabilities.changelog,
    codeSearch: data.capabilities.codeSearch,
    moddy: data.capabilities.moddy,
    profiling: {
      deployed: data.capabilities.profiling.deployed,
      isActive: session !== null,
      session
    },
    loading,
    error,
    refetch
  };
};
